/**
 * Fades an element out.
 *
 * @param {HTMLElement} el
 * @param {number} timeout - Animation duration in milliseconds.
 * @returns {void}
 */
export function fadeOut(el = null, timeout = 250) {
    if (!el) return;

    el.style.opacity = 1;
    el.style.transition = `opacity ${timeout}ms`;
    el.style.opacity = 0;
    setTimeout(() => {
        el.style.display = "none";
    }, timeout);
}
/**
 * Fades an element in.
 *
 * @param {HTMLElement} el
 * @param {number} timeout - Animation duration in milliseconds.
 * @returns {void}
 */
export function fadeIn(el = null, timeout = 250) {
    if (!el) return;

    el.style.opacity = 0;
    el.style.display = "block";
    el.style.transition = `opacity ${timeout}ms`;
    setTimeout(() => {
        el.style.opacity = 1;
    }, 10);
}

/**
 * Slides an element up and hides it.
 *
 * @param {HTMLElement} el
 * @param {number} duration - Animation duration in milliseconds.
 * @returns {void}
 */
export function slideUp(el = null, duration = 250) {
    if (!el || el.classList.contains("_slide")) return;

    el.classList.add("_slide");
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.height = el.offsetHeight + "px";
    el.offsetHeight;
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingBlockStart = 0;
    el.style.paddingBlockEnd = 0;
    el.style.marginBlockStart = 0;
    el.style.marginBlockEnd = 0;
    window.setTimeout(() => {
        el.hidden = true;
        el.style.removeProperty("height");
        el.style.removeProperty("padding-block-start");
        el.style.removeProperty("padding-block-end");
        el.style.removeProperty("margin-block-start");
        el.style.removeProperty("margin-block-end");
        el.style.removeProperty("overflow");
        el.style.removeProperty("transition-duration");
        el.style.removeProperty("transition-property");
        el.classList.remove("_slide");
    }, duration);
}

/**
 * Slides an element down and shows it.
 *
 * @param {HTMLElement} el
 * @param {number} duration - Animation duration in milliseconds.
 * @returns {void}
 */
export function slideDown(el = null, duration = 250) {
    if (!el || el.classList.contains("_slide")) return;

    el.classList.add("_slide");
    if (el.hidden) el.hidden = false;
    let height = el.offsetHeight;
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingBlockStart = 0;
    el.style.paddingBlockEnd = 0;
    el.style.marginBlockStart = 0;
    el.style.marginBlockEnd = 0;
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.height = height + "px";
    el.style.removeProperty("padding-block-start");
    el.style.removeProperty("padding-block-end");
    el.style.removeProperty("margin-block-start");
    el.style.removeProperty("margin-block-end");
    window.setTimeout(() => {
        el.style.removeProperty("height");
        el.style.removeProperty("overflow");
        el.style.removeProperty("transition-duration");
        el.style.removeProperty("transition-property");
        el.classList.remove("_slide");
    }, duration);
}

/**
 * Toggles an element with a slide animation.
 *
 * @param {HTMLElement} el
 * @param {number} duration - Animation duration in milliseconds.
 * @returns {void}
 */
export function slideToggle(el = null, duration = 250) {
    if (!el) return;

    if (el.hidden) {
        return slideDown(el, duration);
    } else {
        return slideUp(el, duration);
    }
}
